import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetproductionneedspage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetProductionNeedsPage } = await import(
        /* webpackChunkName: "BudgetProductionVolumesPage" */
        '../../../components/pages/private/BudgetProductionNeedsPage'
      )
      return {
        default: BudgetProductionNeedsPage,
      }
    })}
    exact
    key={paths.needsGeneration}
    path={paths.needsGeneration}
  />,
]
